import { render, staticRenderFns } from "./RemoveFontModal.vue?vue&type=template&id=b9721b5a&scoped=true&"
import script from "./RemoveFontModal.vue?vue&type=script&lang=ts&"
export * from "./RemoveFontModal.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveFontModal.vue?vue&type=style&index=0&id=b9721b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9721b5a",
  null
  
)

export default component.exports